import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuPlanParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: MenuPlanParamsState = {
  params: null,
};

const ItemInitiateMenuProjectionSliceParams = createSlice({
  name: 'ItemInitiateMenuProjectionParams',
  initialState,
  reducers: {
     
    setMenuProjectionParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
     // console.log("Payload in ItemInitiateMenuProjectionSliceParams.ts", action.payload);
    },
  },
});

export const { setMenuProjectionParams } = ItemInitiateMenuProjectionSliceParams.actions;

export default ItemInitiateMenuProjectionSliceParams.reducer;